import React from "react";

const PromptExtractor: React.FC = () => {
  // Track page view (disabled for showcase)
  React.useEffect(() => {
    // Analytics removed for showcase site
  }, []);
  return (
    <div className="min-h-screen bg-gray-50 p-6 pb-32 md:pb-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center py-20">
          <div className="mb-6">
            <svg
              className="w-20 h-20 mx-auto text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1}
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
              />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Prompt Extractor
          </h1>
          <div className="inline-flex items-center px-4 py-2 bg-yellow-100 text-yellow-800 text-sm font-medium rounded-full">
            Coming Soon
          </div>
          <p className="text-lg text-gray-600 mt-6 max-w-2xl mx-auto">
            We're working on an amazing tool to help you extract and analyze
            prompts from videos. Stay tuned for updates!
          </p>
        </div>
      </div>
    </div>
  );
};

export default PromptExtractor;
